module.exports = __webpack_public_path__ + "img/code.6467d530.png";